import { ciUndo } from '~/icons/source/regular/undo'
import { ciRedo } from '~/icons/source/regular/redo'
import { ciBold } from '~/icons/source/regular/bold'
import { ciBold as ciBoldSolid } from '~/icons/source/solid/bold'
import { ciItalic } from '~/icons/source/regular/italic'
import { ciItalic as ciItalicSolid } from '~/icons/source/solid/italic'
import { ciUnderline } from '~/icons/source/regular/underline'
import { ciUnderline as ciUnderlineSolid } from '~/icons/source/solid/underline'
import { ciAlignLeft } from '~/icons/source/regular/align-left'
import { ciAlignCenter } from '~/icons/source/regular/align-center'
import { ciAlignRight } from '~/icons/source/regular/align-right'
import { ciList } from '~/icons/source/regular/list'
import { ciList as ciListSolid } from '~/icons/source/solid/list'
import { ciListOrdered } from '~/icons/source/regular/list-ordered'
import { ciListOrdered as ciListOrderedSolid } from '~/icons/source/solid/list-ordered'
import { ciImage } from '~/icons/source/regular/image'
import { ciLink } from '~/icons/source/regular/link'
import { ToolbarConfig } from '~/models/rich-text/types'

// The extension order matters and is reflected in the toolbar (menu bar)
// Extensions without active state capability are using only the regular icon
// translation.text are only for fallback reasons, translations are handled to the component
export const toolbarConfig: ToolbarConfig[] = [
  {
    name: 'history',
    inMenu: true,
    hasGap: true,
    commands: [
      {
        actionName: 'undo',
        namespace: 'history',
        icon: { regular: ciUndo },
        translation: { key: 'undo' }
      },
      {
        actionName: 'redo',
        namespace: 'history',
        icon: { regular: ciRedo },
        translation: { key: 'redo' }
      }
    ]
  },
  {
    name: 'heading',
    inMenu: true,
    hasGap: true,
    commands: [
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        options: { level: 1 },
        translation: { key: 'heading_1' }
      },
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        options: { level: 2 },
        translation: { key: 'heading_2' }
      },
      {
        actionName: 'toggleHeading',
        namespace: 'heading',
        options: { level: 3 },
        translation: { key: 'heading_3' }
      }
    ]
  },
  {
    name: 'bold',
    inMenu: true,
    commands: [
      {
        actionName: 'toggleBold',
        namespace: 'bold',
        icon: { regular: ciBold, solid: ciBoldSolid },
        translation: { key: 'bold' }
      }
    ]
  },
  {
    name: 'italic',
    inMenu: true,
    commands: [
      {
        actionName: 'toggleItalic',
        namespace: 'italic',
        icon: { regular: ciItalic, solid: ciItalicSolid },
        translation: { key: 'italic' }
      }
    ]
  },
  {
    name: 'underline',
    inMenu: true,
    hasGap: true,
    commands: [
      {
        actionName: 'toggleUnderline',
        namespace: 'underline',
        icon: { regular: ciUnderline, solid: ciUnderlineSolid },
        translation: { key: 'underline' }
      }
    ]
  },
  {
    name: 'textAlign',
    inMenu: true,
    hasGap: true,
    commands: [
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: { regular: ciAlignLeft },
        options: 'left',
        translation: { key: 'align_left' }
      },
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: { regular: ciAlignCenter },
        options: 'center',
        translation: { key: 'align_center' }
      },
      {
        actionName: 'setTextAlign',
        namespace: 'textAlign',
        icon: { regular: ciAlignRight },
        options: 'right',
        translation: { key: 'align_right' }
      }
    ]
  },
  {
    name: 'bulletList',
    inMenu: true,
    commands: [
      {
        actionName: 'toggleBulletList',
        namespace: 'bulletList',
        icon: { regular: ciList, solid: ciListSolid },
        translation: { key: 'bullet_list' }
      }
    ]
  },
  {
    name: 'orderedList',
    inMenu: true,
    hasGap: true,
    commands: [
      {
        actionName: 'toggleOrderedList',
        namespace: 'orderedList',
        icon: { regular: ciListOrdered, solid: ciListOrderedSolid },
        translation: { key: 'ordered_list' }
      }
    ]
  },
  {
    name: 'image',
    inMenu: true,
    commands: [
      {
        actionName: 'setImage',
        namespace: 'image',
        icon: { regular: ciImage },
        translation: { key: 'image' }
      }
    ]
  },
  {
    name: 'link',
    inMenu: true,
    commands: [
      {
        actionName: 'toggleLink',
        namespace: 'link',
        icon: { regular: ciLink },
        translation: { key: 'link' }
      }
    ]
  }
]
